<template>
    <v-layout align-center :class="{'wrap justify-center': $vuetify.breakpoint.smAndDown}">
        <div class="profile__stat"
             :class="{'border-green': color=='green', 'border-red' : color=='red', 'border-grey' : color=='grey',
                      'ml-0 mb-2': $vuetify.breakpoint.mdAndDown,'mr-3': $vuetify.breakpoint.mdAndUp}"
        >{{ number || '-' }}</div>
        <v-flex class="md8 profile__stat-text ml-2"
                :class="{'red-text': color=='red', 'green-text': color=='green','dark-grey-text': color=='grey',
                         'mr-3' : $vuetify.breakpoint.sm}"
        >{{ text }}</v-flex>
    </v-layout>
</template>

<script>

export default {
  props: {
    number: {
      type: Number,
    },
    text: {
      type: String,
    },
    color: {
      type: String,
    },
  },
  computed: {
  },
};
</script>
